import { ReactElement } from 'react'
import { ViewProps } from 'react-native'
import { Head, useNumberParams } from 'zens-router'
import { useCompany } from 'zens-store'

import { PageHeader, PageHeaderProps } from 'zens-storybook'

interface Props extends PageHeaderProps {}

const LayoutPageHeader = (props: Props) => {
  const { title, ...otherProps } = props

  const [{ companyId }] = useNumberParams()
  const company = useCompany({ companyId })

  const headerParts = ['DMS', company.data?.name, title]

  return (
    <>
      <Head>
        <title>
          {headerParts.filter((part, index) => part && headerParts.slice(0, index).indexOf(part) <= 0).join(' | ')}
        </title>
      </Head>
      <PageHeader title={title} {...otherProps} />
    </>
  )
}

interface SkeletonProps extends ViewProps {
  breadcrumb?: true
  title?: true
  accessory?: ReactElement
}
LayoutPageHeader.Skeleton = (props: SkeletonProps) => <PageHeader.Skeleton {...props} />

export default LayoutPageHeader
